import { Skeleton } from 'ui/skeleton/Skeleton';
import { StyledDT, StyledDD } from './DetailField.styled';

export const DetailField = ({
  children,
  name,
  value,
  isFetchingValue,
}: {
  children?: React.ReactNode | undefined;
  name: string;
  value?: string;
  isFetchingValue: boolean;
}) => (
  <div>
    <StyledDT>{name}</StyledDT>
    <StyledDD>
      {isFetchingValue ? (
        <Skeleton data-test="sentMessage-detailField-skeleton" height={16} />
      ) : (
        <>
          {value && <span>{value}</span>}
          {children}
        </>
      )}
    </StyledDD>
  </div>
);
